import {MenuItem, Select} from "@mui/material";

const DEFAULT_VAT = 10;

export default function ({onChange}) {
    return (
        <Select
            variant={"standard"}
            defaultValue={DEFAULT_VAT}
            onChange={onChange}
            fullWidth
            data-test="insurance-select-vat"
        >
            <MenuItem value={0}>0 %</MenuItem>
            <MenuItem value={10}>10 %</MenuItem>
            <MenuItem value={20}>20 %</MenuItem>
        </Select>
    );
}
